import React from "react";
import PropTypes from "prop-types";
import EMPDialog from "../shared/components/EMPDialog/EMPDialog";
import { Typography } from "@mui/material";

const ErrorProcessingDialog = (props) => {
  const { open, close, title, body, buttonText } = props;

  return (
    <EMPDialog
      dialogTitle={title}
      open={open}
      hasCloseIcon
      handleClose={close}
      hasActionButton
      actionButtonText={buttonText}
      onConfirm={close}
    >
      <Typography variant="body1">{body}</Typography>
    </EMPDialog>
  );
};

ErrorProcessingDialog.propTypes = {
  body: PropTypes.node.isRequired,
  buttonText: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default ErrorProcessingDialog;
